import React, { Component } from 'react';
import StepOne from '../components/step_one';
import StepTwo from '../components/step_two';
import StepThree from '../components/step_three';
import ProgressBar from '../components/progress_bar';
import Header from '../components/header';
import SettingsModal from '../components/settings_modal';
import StationService from '../services/station_service';

class ConvertScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            station: '',
            format: '',
            error: '',
            success: '',
            loading: false,
            availableVersions: [],
            versionsLoading: false,
            versionsError: '',
            showSettingsModal: false,
            documentsChecked: {
                docA: false,
                docB: false,
                docC: false,
                docD: false,
            },
            // Load paths from localStorage
            inputsPath: localStorage.getItem("inputsPath") || "",
        };
    }

    setStation = (value) => {
        this.setState({
            station: value,
            availableVersions: [],
            versionsLoading: Boolean(value),
            versionsError: '',
        });
        if (value) this.loadStationVersions(value);
    };

    loadStationVersions = async (stationName) => {
        try {
            const response = await StationService.getStationVersions(stationName);
            this.setState(prev => prev.station === stationName ? {
                availableVersions: response.data?.versions || [],
                versionsLoading: false,
                versionsError: '',
            } : null);
        } catch (err) {
            const message = err.response?.data?.detail || err.response?.data?.message || err.message || 'Could not load versions for this station.';
            this.setState(prev => prev.station === stationName ? {
                availableVersions: [],
                versionsLoading: false,
                versionsError: message,
            } : null);
        }
    };

    setFormat = (value) => {
        this.setState({ format: value });
    };

    setDocumentsChecked = (docs) => {
        this.setState({ documentsChecked: docs });
    };

    componentDidMount() {
        const { inputsPath } = this.state;

        const pathsReady = inputsPath;

        if (!pathsReady) {
            this.setState({ showSettingsModal: true });
        }
    }

    closeSettingsModal = () => {
        this.setState({
            showSettingsModal: false,
            inputsPath: localStorage.getItem("inputsPath") || "",
        });
    };

    handleNext = () => {
        const { step, station } = this.state;

        if (step === 1) {
            if (!station) {
                this.setState({ error: 'Connection Error: Device not recognized.' });
                return;
            }

            this.setState({ error: '', loading: true });

            setTimeout(() => {
                this.setState({ loading: false, step: 2 });
            }, 1500);
        } else if (step === 2) {
            this.setState({ success: 'Raw Documents Successful', step: 3 });
        }
    };


    render() {
        const {
            step,
            station,
            format,
            error,
            loading,
            documentsChecked,
            success,
            inputsPath,
            showSettingsModal,
            availableVersions,
            versionsLoading,
            versionsError,
        } = this.state;

        const pathsReady = inputsPath;

        return (
            <div>
                {showSettingsModal && <SettingsModal closeModal={this.closeSettingsModal} />}
                <Header />

                {!pathsReady && (
                    <div className="alert alert-danger text-center fw-bold mx-auto" style={{ maxWidth: '600px' }}>
                        Required folder paths are missing. Please configure them in Settings.
                    </div>
                )}

                <div className='row mx-0 justify-content-center'>
                    <div className='col-2 col-md-2 px-0 mt-4'>
                        <ProgressBar step={step} />
                    </div>
                    <div className='col-10 col-md-6 px-0'>
                        {/* STEP 01 */}
                        {pathsReady && (
                            <div className={`mb-4 ${step !== 1 ? 'opacity-50 pointer-events-none' : ''}`}>
                                <StepOne
                                    station={station}
                                    setStation={this.setStation}
                                    error={error}
                                    sourcePath={inputsPath}
                                    handleNext={step === 1 ? this.handleNext : () => { }}
                                    loading={loading}
                                    setLoading={(val) => this.setState({ loading: val })}
                                    disabled={step !== 1}
                                />
                            </div>
                        )}

                        {/* STEP 02 */}
                        {step >= 2 && pathsReady && (
                            <div className={`mb-2`}>
                                <StepTwo
                                    station={station}
                                    loading={loading}
                                    documentsChecked={documentsChecked}
                                    setDocumentsChecked={this.setDocumentsChecked}
                                    handleNext={step === 2 ? this.handleNext : () => { }}
                                    success={success}
                                    outputPath={inputsPath}
                                    disabled={step !== 2}
                                />
                            </div>
                        )}

                        {/* STEP 03 */}
                        {step >= 3 && pathsReady && (
                            <div className={`mb-4 ${step !== 3 ? 'opacity-50' : ''}`}>
                                <StepThree
                                    station={station}
                                    format={format}
                                    setFormat={this.setFormat}
                                    loading={loading}
                                    handleNext={step === 3 ? this.handleNext : () => { }}
                                    inputPath={inputsPath}
                                    outputPath={inputsPath}
                                    disabled={step !== 3}
                                    availableVersions={availableVersions}
                                    versionsLoading={versionsLoading}
                                    versionsError={versionsError}
                                />
                            </div>
                        )}
                    </div>
                </div>

            </div>
        );
    }

}

export default ConvertScreen;
